import { ORGANIZATIONS_API_ROOT } from '../../config/api'
import { CALL_ORGANIZATIONS_API } from '../../middleware/authHeaders'

export const ACCOUNTS_GET_ORGS_REQUEST = 'ACCOUNTS_GET_ORGS_REQUEST'
export const ACCOUNTS_GET_ORGS_SUCCESS = 'ACCOUNTS_GET_ORGS_SUCCESS'
export const ACCOUNTS_GET_ORGS_FAILURE = 'ACCOUNTS_GET_ORGS_FAILURE'

const addParamIfValueExists = (route, param, value) => {
  if (value) {
    return `${route}&${param}=${typeof value === 'string' ? value.trim() : value}`
  }
  return route
}

export const getAccountsOrgs =
  (
    pageNumber,
    pageSize,
    ein = '',
    uei = '',
    ncesId = '',
    ukcn = '',
    cacrn = '',
    abn = '',
    iercn = '',
    nllei = '',
    frsiren = '',
    frrna = '',
    name = '',
    city = '',
    postalCode = '',
    isExcludedIrsPub78 = false,
    isExcludedCaCharityRegistry = false,
    isExcludedSplcHateGroup = false,
    isExcludedSplcAntiGovt = false,
    dataSource = '',
    region = '',
    country = ''
  ) =>
  dispatch => {
    let endpoint = `${ORGANIZATIONS_API_ROOT}/v2/organizations/search/?pageNumber=${pageNumber}&pageSize=${pageSize}`

    endpoint = addParamIfValueExists(endpoint, 'ein', ein)
    endpoint = addParamIfValueExists(endpoint, 'uei', uei)
    endpoint = addParamIfValueExists(endpoint, 'ncesId', ncesId)
    endpoint = addParamIfValueExists(endpoint, 'ukcn', ukcn)
    endpoint = addParamIfValueExists(endpoint, 'cacrn', cacrn)
    endpoint = addParamIfValueExists(endpoint, 'abn', abn)
    endpoint = addParamIfValueExists(endpoint, 'iercn', iercn)
    endpoint = addParamIfValueExists(endpoint, 'nllei', nllei)
    endpoint = addParamIfValueExists(endpoint, 'frsiren', frsiren)
    endpoint = addParamIfValueExists(endpoint, 'frrna', frrna)
    endpoint = addParamIfValueExists(endpoint, 'name', name ? encodeURI(name) : '')
    endpoint = addParamIfValueExists(endpoint, 'city', city)
    endpoint = addParamIfValueExists(endpoint, 'region', region)
    endpoint = addParamIfValueExists(endpoint, 'country', country)
    endpoint = addParamIfValueExists(endpoint, 'postalCode', postalCode)
    endpoint = addParamIfValueExists(endpoint, 'isExcludedIrsPub78', isExcludedIrsPub78)
    endpoint = addParamIfValueExists(
      endpoint,
      'isExcludedCaCharityRegistry',
      isExcludedCaCharityRegistry
    )
    endpoint = addParamIfValueExists(endpoint, 'isExcludedSplcHateGroup', isExcludedSplcHateGroup)
    endpoint = addParamIfValueExists(endpoint, 'isExcludedSplcAntiGovt', isExcludedSplcAntiGovt)
    endpoint = addParamIfValueExists(endpoint, 'dataSource', dataSource)

    return dispatch({
      [CALL_ORGANIZATIONS_API]: {
        method: 'GET',
        endpoint,
        types: [ACCOUNTS_GET_ORGS_REQUEST, ACCOUNTS_GET_ORGS_SUCCESS, ACCOUNTS_GET_ORGS_FAILURE],
      },
    })
  }

export const ACCOUNTS_CLEAR_ORGS = 'ACCOUNTS_CLEAR_ORGS'
export const clearAccountsOrgs = () => ({
  type: ACCOUNTS_CLEAR_ORGS,
})

export const ACCOUNTS_GET_ORG_DETAILS_REQUEST = 'ACCOUNTS_GET_ORG_DETAILS_REQUEST'
export const ACCOUNTS_GET_ORG_DETAILS_SUCCESS = 'ACCOUNTS_GET_ORG_DETAILS_SUCCESS'
export const ACCOUNTS_GET_ORG_DETAILS_FAILURE = 'ACCOUNTS_GET_ORG_DETAILS_FAILURE'

export const getAccountsOrgDetails = orgId => dispatch => {
  const endpoint = `${ORGANIZATIONS_API_ROOT}/v2/organizations/${orgId}`

  return dispatch({
    [CALL_ORGANIZATIONS_API]: {
      method: 'GET',
      endpoint,
      types: [
        ACCOUNTS_GET_ORG_DETAILS_REQUEST,
        ACCOUNTS_GET_ORG_DETAILS_SUCCESS,
        ACCOUNTS_GET_ORG_DETAILS_FAILURE,
      ],
    },
  })
}

export const ACCOUNTS_REFRESH_ORG_DATA_REQUEST = 'ACCOUNTS_REFRESH_ORG_DATA_REQUEST'
export const ACCOUNTS_REFRESH_ORG_DATA_SUCCESS = 'ACCOUNTS_REFRESH_ORG_DATA_SUCCESS'
export const ACCOUNTS_REFRESH_ORG_DATA_FAILURE = 'ACCOUNTS_REFRESH_ORG_DATA_FAILURE'

export const postRefreshOrgData = orgId => dispatch => {
  const endpoint = `${ORGANIZATIONS_API_ROOT}/v2/organizations/${orgId}/refresh`

  return dispatch({
    [CALL_ORGANIZATIONS_API]: {
      method: 'POST',
      endpoint,
      types: [
        ACCOUNTS_REFRESH_ORG_DATA_REQUEST,
        ACCOUNTS_REFRESH_ORG_DATA_SUCCESS,
        ACCOUNTS_REFRESH_ORG_DATA_FAILURE,
      ],
    },
  })
}

export const ACCOUNTS_CLEAR_ORG_DETAILS = 'ACCOUNTS_CLEAR_ORG_DETAILS'
export const clearAccountsOrgDetails = () => ({
  type: ACCOUNTS_CLEAR_ORG_DETAILS,
})

export const SET_FILTERS = 'SET_FILTERS'
export const setOrganizationFilters = filters => ({
  type: SET_FILTERS,
  payload: filters,
})

export const SET_QUERY = 'SET_QUERY'
export const setOrganizationQuery = query => ({
  type: SET_QUERY,
  payload: query,
})

// SELECTORS
export const selectAccountsOrgsSlice = state => state.accounts.accountsOrgs
export const selectAccountsOrgs = state => selectAccountsOrgsSlice(state).orgList
export const selectSelectedOrg = id => state => selectAccountsOrgsSlice(state).selectedOrg?.[id]
export const selectStateFilters = state => state.accounts.accountsOrgs.filters
export const selectOrganizationQueryState = state => state.accounts.accountsOrgs.queryState
// STATE
const ACCOUNTS_INITIAL_STATE = {
  orgList: null,
  selectedOrg: null,
  filters: {},
  queryState: {
    pageSize: 10,
    currentPage: 1,
    nameQuery: '',
    einQuery: '',
    ueiQuery: '',
    ncesIdQuery: '',
    ukcnQuery: '',
    cacrnQuery: '',
    abnQuery: '',
    iercnQuery: '',
    nlleiQuery: '',
    frsirenQuery: '',
    frrnaQuery: '',
    city: '',
    postalCode: '',
    isExcludedIrsPub78: false,
    isExcludedCaCharityRegistry: false,
    isExcludedSplcHateGroup: false,
    isExcludedSplcAntiGovt: false,
    dataSource: '',
    region: '',
    country: '',
  },
}

// REDUCERS
const accountsOrgs = (state = ACCOUNTS_INITIAL_STATE, { type, payload } = {}) =>
  ({
    [ACCOUNTS_GET_ORGS_SUCCESS]: (currentState, newPayload) => ({
      ...currentState,
      orgList: newPayload,
    }),
    [ACCOUNTS_CLEAR_ORGS]: currentState => ({
      ...currentState,
      orgList: null,
    }),
    [ACCOUNTS_GET_ORG_DETAILS_SUCCESS]: (currentState, newPayload) => ({
      ...currentState,
      selectedOrg: {
        ...currentState.selectedOrg,
        [newPayload.id]: newPayload,
      },
    }),
    [ACCOUNTS_CLEAR_ORG_DETAILS]: currentState => ({
      ...currentState,
      selectedOrg: null,
    }),
    [SET_FILTERS]: (currentState, newFilters) => ({
      ...currentState,
      filters: {
        ...currentState.filters,
        ...newFilters,
      },
    }),
    [SET_QUERY]: (currentState, newQuery) => ({
      ...currentState,
      queryState: {
        ...currentState.queryState,
        ...newQuery,
      },
    }),
  }[type]?.(state, payload) || state)

export default accountsOrgs
